export const BRAND_KEY = 'braun'
export const BRAND_LABEL = 'Braun'
export const BRAND_SHORT_LABEL = 'BR'
export const BRAND_CODE_MARKETING_CLOUD = 'brn'
export const BRAND_INFO = {
    key: BRAND_KEY,
    label: BRAND_LABEL,
    short_label: BRAND_SHORT_LABEL,
}
export const BRAND_KEY_FILTER_CS = BRAND_KEY
export const DEFAULT_SITE = 'braun-eu'
export const MAIN_DOMAIN = 'braunhousehold.com'
export const GTM_DOMAIN = 'sgtm.braunhousehold.com'
